<script setup lang="ts">

import { RowSlot } from '@shared/ui/other'
import { InputPrimary } from '@shared/ui/fields'

import { useKidFields } from '../model/kid-fields.hook'

defineOptions({
  name: 'KidInputName',
})

const {
  refName,
  setName,
} = useKidFields()
</script>

<template>
  <RowSlot label="Name">
    <InputPrimary
      id="kid-name"
      name="name"
      type="text"
      placeholder="Type here..."
      :value="refName"
      @update:value="setName"
    />
  </RowSlot>
</template>
